// extracted by mini-css-extract-plugin
export default {"chip":"ChipButton_chip__T57uI"};